import BlockRangeSeriesPointBottom from '../../assets/images/BlockRangeSeriesPointBottom.svg';
import BlockRangeSeriesPointTop from '../../assets/images/BlockRangeSeriesPointTop.svg';

import { IChartingAssets } from './IChartingAssets.js';
/* [AddAsset: import] */

export const chartingAssets: IChartingAssets = {
	blockRangeChart: {
		seriesPointBottom: BlockRangeSeriesPointBottom,
		seriesPointTop: BlockRangeSeriesPointTop,
		/* [AddAsset: blockRangeChart] */
	},
	/* [InitComponentAsset: assetKey] */
};
